<template>
  <div>
    <div class="content-wrapper">
      <label class="mr-2 select-label">{{ title }}</label>
      <v-select
        :style="signalsComboboxStyle"
        class="combo-box signal-combobox"
        variant="outlined"
        density="compact"
        :items="values"
        item-title="title"
        item-value="id"
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        hide-details
        return-object
      ></v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScaleCombobox",
  emits: ["update:modelValue"],

  props: {
    values: Array,
    modelValue: Object,
    title: String,
    width: Number
  },

  computed: {
    signalsComboboxStyle() {
      return {
        width: `${this.width}px`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/combobox";

.content-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.select-label {
  font-size: 0.8em;
}
.signal-combobox {
  display: inline-block;
}
</style>
